import { AppointmentTypeForm } from "../AppointmentTypeForm";

export const AddAppointmentType = () => {
  return <AppointmentTypeForm />;
};
